import styled from "styled-components";

export const StyledAddPost = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: rgb(105, 105, 109);
`;
